<div class="mb-xlg shepherd-measurements">
  <p class="text-info-bold mb-xs text-upper-case">Mediciones agregadas.</p>
  <div class="new-measurement mb-sm" *ngFor="let measurement of measurementsTemporal; index as i">
    <p class="text-info-bold mb-xxs">{{ measurement.name_es }}</p>
    <p class="text-info">{{ measurement.value }} {{ measurement.value > 1 ? measurement.unitMeasurementDefault.namePlural_es :
      measurement.unitMeasurementDefault.name_es }}</p>
  </div>
  <p class="text-info" *ngIf="measurementsTemporal.length === 0">No hay nuevas mediciones agregadas.</p>
</div>

<app-basic-formulas
  [showCard]="false"
  [expertId]="this.expertId"
  [clinicId]="this.clinicId"
  [patientId]="this.patientId"
  [serviceId]="this.serviceId"
  [appointmentId]="this.appointmentId"
  [measurementsTemporal]="this.measurementsTemporal"
></app-basic-formulas>
